import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
var initialResume = {
  summary: null,
  location: null,
  education: [],
  employments: [],
  functionalAreas: [],
  industries: [],
  productTechnologies: [],
  therapeuticAreas: [],
  stagesOfDevelopments: []
};
var initialLinkedIn = {
  summary: null,
  location: null,
  education: [],
  pastRoles: [],
  functionalAreas: [],
  industries: [],
  productTechnologies: [],
  therapeuticAreas: [],
  stagesOfDevelopments: []
};
var initialState = {
  profileSuggestions: {
    updated: false,
    resume: initialResume,
    linkedin: initialLinkedIn,
    merged: {
      location: {
        accepted: true,
        location: null
      },
      bio: {
        accepted: true,
        bio: null
      },
      education: [],
      pastRoles: [],
      functionalAreas: [],
      industries: [],
      productTechnologies: [],
      therapeuticAreas: [],
      stagesOfDevelopments: []
    }
  },
  errors: {
    is: false
  },
  answers: {
    location: null,
    bio: null,
    education: [],
    pastRoles: [],
    functionalAreas: [],
    industries: [],
    productTechnologies: [],
    therapeuticAreas: [],
    stagesOfDevelopments: []
  },
  hasChanged: {
    bio: false,
    location: false,
    education: false,
    pastRoles: false,
    functionalAreas: false,
    industries: false,
    productTechnologies: false,
    therapeuticAreas: false,
    stagesOfDevelopments: false
  }
};
var toCamel = function toCamel(str) {
  return str.replace(/([-_][a-z])/ig, function ($1) {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};
var isObject = function isObject(obj) {
  return obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function';
};
var _keysToCamel = function keysToCamel(obj) {
  if (isObject(obj)) {
    var n = {};
    Object.keys(obj).forEach(function (k) {
      n[toCamel(k)] = _keysToCamel(obj[k]);
    });
    return n;
  }
  if (Array.isArray(obj)) {
    return obj.map(function (i) {
      return _keysToCamel(i);
    });
  }
  return obj;
};
var checkData = function checkData(data) {
  var errors = {
    is: false,
    education: false
  };
  Object.keys(data).forEach(function (key) {
    if (key === 'education') {
      var education = data.education.filter(function (a) {
        return a.accepted;
      });
      errors.education = Array(education.length).fill(false);
    }
  });
  return errors;
};
var parsingPostTreatment = function parsingPostTreatment(mergedValues) {
  var merged = JSON.parse(JSON.stringify(mergedValues));
  merged.pastRoles = (merged.pastRoles || []).map(function (pastRole) {
    return _.mapKeys(pastRole, function (v, k) {
      return _.camelCase(k);
    });
  });
  merged.education = (merged.education || []).map(function (education) {
    return _.mapKeys(education, function (v, k) {
      return _.camelCase(k);
    });
  });
  var pastRoles = (merged.pastRoles || []).map(function (p) {
    return {
      accepted: true,
      pastRole: p
    };
  });
  var education = (merged.education || []).map(function (e) {
    return {
      accepted: true,
      education: e
    };
  });
  var bio = merged.bio;
  var location = merged.location;
  var functionalAreas = (merged.functionalAreas || []).map(function (fa) {
    return {
      accepted: true,
      functionalArea: fa
    };
  });
  var therapeuticAreas = (merged.therapeuticAreas || []).map(function (ta) {
    return {
      accepted: true,
      therapeuticArea: ta
    };
  });
  var industries = (merged.industries || []).map(function (i) {
    return {
      accepted: true,
      industrie: i
    };
  });
  var productTechnologies = (merged.productTechnologies || []).map(function (pt) {
    return {
      accepted: true,
      productTechnologie: pt
    };
  });
  var stagesOfDevelopments = (merged.stagesOfDevelopments || []).map(function (sod) {
    return {
      accepted: true,
      stagesOfDevelopment: sod
    };
  });
  return {
    pastRoles: pastRoles,
    education: education,
    bio: bio,
    location: location,
    functionalAreas: functionalAreas,
    therapeuticAreas: therapeuticAreas,
    industries: industries,
    productTechnologies: productTechnologies,
    stagesOfDevelopments: stagesOfDevelopments
  };
};
var arePastRolesChanged = function arePastRolesChanged(answered, suggested) {
  // There are no suggested past roles, so nothing to udpate
  if (suggested.length === 0) {
    return false;
  }

  // Past roles may be overriden because there are some suggestions
  if (suggested.length > 0 && answered.length !== suggested.length) {
    return true;
  }
  var ans = answered.map(function (d) {
    return _objectSpread(_objectSpread({}, d), {}, {
      startYear: new Date(d.startDate).getFullYear(),
      endYear: new Date(d.endDate).getFullYear()
    });
  }).sort(function (a, b) {
    return b.startYear - a.startYear;
  });
  var sug = suggested.map(function (d) {
    return _objectSpread(_objectSpread({}, d), {}, {
      startYear: new Date(d.startDate).getFullYear(),
      endYear: new Date(d.endDate).getFullYear()
    });
  }).sort(function (a, b) {
    return b.startYear - a.startYear;
  });
  var k = 0;
  var hasChanged = false;
  while (k < sug.length && !hasChanged) {
    if (sug[k].startYear !== ans[k].startYear || sug[k].endYear !== ans[k].endYear || sug[k].title !== ans[k].title || sug[k].companyName !== ans[k].companyName) {
      hasChanged = true;
    }
    k += 1;
  }
  return hasChanged;
};
var areEducationChanged = function areEducationChanged(answered, suggested) {
  // There are no suggested past roles, so nothing to udpate
  if (suggested.length === 0) {
    return false;
  }

  // Past roles may be overriden because there are some suggestions
  if (suggested.length > 0 && answered.length !== suggested.length) {
    return true;
  }
  var ans = answered.sort(function (a, b) {
    return b.startYear - a.startYear;
  });
  var sug = suggested.map(function (d) {
    return _objectSpread(_objectSpread({}, d), {}, {
      startYear: new Date(d.startDate).getFullYear(),
      endYear: new Date(d.endDate).getFullYear()
    });
  }).sort(function (a, b) {
    return b.startYear - a.startYear;
  });
  var k = 0;
  var hasChanged = false;
  while (k < sug.length && !hasChanged) {
    if (sug[k].areaOfStudy !== ans[k].areaOfStudy
    // (sug[k]["degree"] !== ans[k]["degreeId"]) ||
    || sug[k].startYear !== ans[k].startYear || sug[k].endYear !== ans[k].endYear || sug[k].school !== ans[k].school) {
      hasChanged = true;
    }
    k += 1;
  }
  return hasChanged;
};
var mergingResumeAndLinkedInSuggestions = function mergingResumeAndLinkedInSuggestions(profileSuggestions) {
  var resume = profileSuggestions.resume,
    linkedin = profileSuggestions.linkedin;
  var merged = {
    location: {
      accepted: true,
      location: null
    },
    bio: {
      accepted: true,
      bio: null
    },
    education: [],
    pastRoles: [],
    functionalAreas: [],
    industries: [],
    productTechnologies: [],
    therapeuticAreas: [],
    stagesOfDevelopments: []
  };
  if (resume.location) {
    merged.location.location = resume.location;
  }
  if (resume.bio || resume.summary) {
    merged.bio.bio = resume.bio || resume.summary;
  }
  merged.pastRoles = resume.employments.sort(function (a, b) {
    return new Date(b.startDate) - new Date(a.startDate);
  });
  merged.education = resume.education.sort(function (a, b) {
    return new Date(b.startDate) - new Date(a.startDate);
  });
  merged.functionalAreas = linkedin.functionalAreas;
  merged.industries = linkedin.industries;
  merged.productTechnologies = linkedin.productTechnologies;
  merged.therapeuticAreas = linkedin.therapeuticAreas;
  merged.stagesOfDevelopments = linkedin.stagesOfDevelopment;
  return parsingPostTreatment(merged);
};
var profileSuggestionsReducer = function profileSuggestionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var data = action.data;
  var profileSuggestions = state.profileSuggestions,
    answers = state.answers,
    hasChanged = state.hasChanged;
  var merged = profileSuggestions.merged;
  var updated = profileSuggestions.updated;
  var errors = {};
  var newMerged;
  var suggestions;
  var changed;
  var existingAnswers;
  var bioHasChanged;
  var locationHasChanged;
  var pastRolesHasChanged;
  var educationHasChanged;
  switch (action.type) {
    case 'REINITIALIZE_RESUME':
      profileSuggestions.resume = initialResume;
      newMerged = mergingResumeAndLinkedInSuggestions(profileSuggestions);
      return _objectSpread(_objectSpread({}, state), {}, {
        profileSuggestions: _objectSpread(_objectSpread({}, profileSuggestions), {}, {
          merged: newMerged
        })
      });
    case 'RESUME_PARSED':
      data = _.mapKeys(data, function (v, k) {
        return _.camelCase(k);
      });
      profileSuggestions.resume = data;
      updated = true;
      newMerged = mergingResumeAndLinkedInSuggestions(profileSuggestions);
      errors = checkData(newMerged);
      return _objectSpread(_objectSpread({}, state), {}, {
        profileSuggestions: _objectSpread(_objectSpread({}, profileSuggestions), {}, {
          updated: updated,
          merged: newMerged
        }),
        errors: errors
      });
    case 'LINKEDIN_PROFILE_PARSED':
      data = _.mapKeys(data, function (v, k) {
        return _.camelCase(k);
      });
      profileSuggestions.linkedin = data;
      updated = true;
      newMerged = mergingResumeAndLinkedInSuggestions(profileSuggestions);
      errors = checkData(newMerged);
      return _objectSpread(_objectSpread({}, state), {}, {
        profileSuggestions: _objectSpread(_objectSpread({}, profileSuggestions), {}, {
          updated: updated,
          merged: newMerged
        }),
        errors: errors
      });
    case 'PROFILE_SUGGESTIONS_PARSED':
      data = _keysToCamel(data);
      suggestions = data.suggestions;
      changed = data.changed;
      existingAnswers = data.answers;
      merged.location.location = suggestions.location;
      merged.bio.bio = suggestions.bio || suggestions.summary;
      merged.pastRoles = suggestions.pastRoles;
      merged.education = suggestions.education;
      merged.functionalAreas = suggestions.functionalAreas;
      merged.industries = suggestions.industries;
      merged.productTechnologies = suggestions.productTechnologies;
      merged.therapeuticAreas = suggestions.therapeuticAreas;
      merged.stagesOfDevelopments = suggestions.stagesOfDevelopments;
      updated = true;
      newMerged = parsingPostTreatment(merged);
      errors = checkData(newMerged);
      return _objectSpread(_objectSpread({}, state), {}, {
        profileSuggestions: _objectSpread(_objectSpread({}, profileSuggestions), {}, {
          updated: updated,
          merged: newMerged
        }),
        errors: errors,
        hasChanged: changed,
        answers: existingAnswers
      });
    case 'UPDATE_BIO':
      bioHasChanged = hasChanged.bio;
      if (!data.accepted) {
        bioHasChanged = false;
      } else if (answers.bio === data.bio) {
        bioHasChanged = false;
      } else {
        bioHasChanged = true;
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        profileSuggestions: _objectSpread(_objectSpread({}, profileSuggestions), {}, {
          merged: _objectSpread(_objectSpread({}, merged), {}, {
            bio: data
          })
        }),
        hasChanged: _objectSpread(_objectSpread({}, hasChanged), {}, {
          bio: bioHasChanged
        })
      });
    case 'UPDATE_LOCATION':
      locationHasChanged = hasChanged.location;
      if (!data.accepted) {
        locationHasChanged = false;
      } else if (answers.bio === data.location) {
        locationHasChanged = false;
      } else {
        locationHasChanged = true;
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        profileSuggestions: _objectSpread(_objectSpread({}, profileSuggestions), {}, {
          merged: _objectSpread(_objectSpread({}, merged), {}, {
            location: data
          })
        }),
        hasChanged: _objectSpread(_objectSpread({}, hasChanged), {}, {
          location: locationHasChanged
        })
      });
    case 'UPDATE_ARRAY':
      newMerged = _objectSpread(_objectSpread({}, merged), {}, _defineProperty({}, data.id, data.newArray));
      errors = checkData(newMerged);
      pastRolesHasChanged = hasChanged.pastRoles;
      educationHasChanged = hasChanged.education;
      if (data.id === 'education') {
        var acceptedOnes = data.newArray.filter(function (d) {
          return d.accepted;
        }).map(function (d) {
          return d.education;
        }).flat();
        educationHasChanged = areEducationChanged(answers.education, acceptedOnes);
      }
      if (data.id === 'pastRoles') {
        var _acceptedOnes = data.newArray.filter(function (d) {
          return d.accepted;
        }).map(function (d) {
          return d.pastRole;
        }).flat();
        pastRolesHasChanged = arePastRolesChanged(answers.pastRoles, _acceptedOnes);
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        profileSuggestions: _objectSpread(_objectSpread({}, profileSuggestions), {}, {
          merged: newMerged
        }),
        errors: errors,
        hasChanged: _objectSpread(_objectSpread({}, hasChanged), {}, {
          education: educationHasChanged,
          pastRoles: pastRolesHasChanged
        })
      });
    default:
      return state;
  }
};
export default profileSuggestionsReducer;